import { render, staticRenderFns } from "./promotion-reject.vue?vue&type=template&id=7fc78663&"
import script from "./promotion-reject.vue?vue&type=script&lang=js&"
export * from "./promotion-reject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports